module.exports = __webpack_public_path__ + "img/album10_07.ef41b652.jpg";